const globalConsent = {
  gdpr_consent: '--',
  us_privacy: '--',
  debug: false,
  test: false,
  testDisplay: false,
  player_load_id: 0,
};
export default globalConsent;
